module.exports = __webpack_public_path__ + "logo-1f0051576ffa1848b311a3c38205afc1.png";